// extracted by mini-css-extract-plugin
module.exports = {"firstRow":"styles_firstRow__16qYv","name":"styles_name__3WsZ3"};